import React, { Component } from 'react'
import { connect } from 'react-redux'
import SostaOnlineApiService from '../../../services/SostaOnlineApiService'
import MarkTypeExpirationSetting from './MarkTypeExpirationSetting'

const mapStateToProps = state => {
  return {
    backofficeValues: state.form.backofficeSettings
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

class BackofficeSettings extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: false,
      markTypes: [],
      settings: []
    }
  }

  async componentWillMount () {
    this.setState({ loading: true })
    const [markTypes, settings] = await Promise.all([
      SostaOnlineApiService.fetchMarkTypes(),
      SostaOnlineApiService.fetchSettings()
    ])
    this.setState({ settings: settings.data, markTypes: markTypes.data, loading: false })
  }

  render () {
    const { loading, markTypes, settings } = this.state
    if (loading) {
      return <div className="text-primary">Caricamento in corso...</div>
    }

    return (
      <div className="panel panel-default panel-border">
        <div className="panel-body">
          <h2 className="title">Impostazioni di Sistema</h2>
          <fiedset>
            <div className="titolo-categoria">
              <legend className="text-left">Data di Scadenza Contrassegni</legend>
            </div>
          </fiedset>
          {markTypes.map((item, index) => {
            return (
              <MarkTypeExpirationSetting
                key={`mark-expiration-${item.id}`}
                markType={item}
                setting={settings.find(setting => setting.name === 'MarkExpirationDate_' + item.id)}
              />
            )
          })}
        </div>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BackofficeSettings)



// WEBPACK FOOTER //
// ./src/containers/Backoffice/Settings/BackofficeSettings.js